/**
 * 违规信息处理工具
 * @author dongdong.fdd
 * @date 2025/11/28
 */

/**
 * 解析违规详情，返回格式化的违规原因
 * @param illicit 是否违规标记（1-违规，0-正常）
 * @param illicitDetails 违规详情 JSON 字符串
 * @returns 格式化的违规原因文本，如果不违规则返回 null
 */
export const getIllicitReason = (illicit: number | null | undefined, illicitDetails: string | null | undefined): string | null => {
  if (!illicit || illicit !== 1 || !illicitDetails) return null;

  try {
    const details = JSON.parse(illicitDetails);
    const data = details.data;

    if (!data) return '违规内容';

    const reasons: string[] = [];

    // 色情信息
    if (data.porn_info?.hit_flag === 1) {
      const label = data.porn_info.label || '';
      const score = data.porn_info.score || 0;
      reasons.push(`色情(${label ? label + ' ' : ''}${score}分)`);
    }

    // 政治敏感信息
    if (data.politics_info?.hit_flag === 1) {
      const label = data.politics_info.label || '';
      const score = data.politics_info.score || 0;
      reasons.push(`政治敏感(${label ? label + ' ' : ''}${score}分)`);
    }

    return reasons.length > 0 ? reasons.join(', ') : '违规内容';
  } catch (e) {
    console.error('解析违规详情失败:', e);
    return '违规内容';
  }
};
